const tabs = () => {
  const tabs = document.getElementsByClassName('tabs__button')
  const categories = document.getElementsByClassName('programme__category')
  const isMobileDevice = window.navigator.userAgent.toLowerCase().includes("mobi")
  const tabsIsActive = 'tabs--is-active'
  const tabsIsHidden = 'tabs--is-hidden'
  const dataBlockAttribute = 'data-block'

  const showMotionsByLocation = (tabAttribute, category) => {
    const categoryAttribute = category.getAttribute(dataBlockAttribute)

    if (tabAttribute !== categoryAttribute) {
      category.classList.add(tabsIsHidden)
    } else {
      category.classList.remove(tabsIsHidden)
    }
  }

  /* If user is on mobile device we only show the timeblocks
     from the first location */
  if (isMobileDevice && tabs[1]) {
    const tabAttribute = tabs[1].getAttribute(dataBlockAttribute)
    tabs[1].classList.add(tabsIsActive)

    for (let category of categories) {
      showMotionsByLocation(tabAttribute, category)
    }
  }

  for (let tab of tabs) {
    tab.addEventListener('click', () => {
      const activeTab = document.querySelector(`.${tabsIsActive}`)
      const tabAttribute = tab.getAttribute(dataBlockAttribute)

      if (activeTab !== null) activeTab.classList.remove(tabsIsActive)

      /* scrollIntoView parameters don't work on Safari */
      if (!tab.classList.contains(tabsIsActive)) {
        tab.classList.add(tabsIsActive)
        tab.scrollIntoView({
          inline: 'center',
          behavior: 'smooth'
        })
      }

      for (let category of categories) {
        showMotionsByLocation(tabAttribute, category)
      }
    })
  }
}

export default tabs


// WEBPACK FOOTER //
// /Users/sandersturing/Sites/SD/demo.test/frontend/source/javascript/components/tabs.js